import {textSizes} from '@stencil/build-theme/src/build-theme';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const DealText = styled.span`
  ${textSizes.SmallW1};
  color: ${props => (props.textColor ? props.textColor : 'fff')};
`;
